<template>
  <h1 class="title-container">
    <div class="msg-container">
      <p class="msg-line">{{ msgLine1 }}</p>
      <p class="msg-line">{{ msgLine2 }}</p>
    </div>
    <div class="submsg-container">
      <p class="submsg-line">{{ submsgLine1 }}</p>
      <p class="submsg-line">{{ submsgLine2 }}</p>
    </div>
  </h1>
</template>

<script>
export default {
  name: "TwoLineTitle",
  props: {
    msgLine1: String,
    msgLine2: String,
    submsgLine1: String,
    submsgLine2: String,
  },
};
</script>

<style scoped>
h1 {
  @apply text-2xl font-bold mt-6 py-2 relative border-b-2;
  margin-bottom: 15px;
  border-bottom-color: #b2a5fc;
  display: flex;
  justify-content: flex-start; /* 全体は左寄せ */
  align-items: flex-start;
  width: 100%;
  position: relative;
}

h1:after {
  @apply font-bold py-2 absolute border-b-2 w-1/5 block;
  content: " ";
  bottom: -2px;
  border-bottom-color: #1b1d99;
}

/* 横並びの親要素 */
.title-container {
  display: flex;
  gap: 36px; /* パーツ間の隙間 */
  padding-left: 0; /* 必要に応じて調整 */
  align-items: flex-end;
}

/* メインタイトルのラッパー */
.msg-container {
  width: auto; /* 固定幅を外し内容の幅に合わせる */
  display: flex;
  flex-direction: column;
  align-items: center; /* テキスト中央揃え */
  text-align: center;
  justify-content: center;
  padding-left: 0; /* 左余白調整 */
}

/* サブタイトルのラッパー */
.submsg-container {
  width: auto;
  display: flex;
  flex-direction: column;
  align-items: center; /* テキスト中央揃え */
  text-align: center;
  justify-content: center;
  font-style: italic;
  color: #b2a5fc;
  font-size: 1.125rem;
  padding-left: 0; /* 左余白調整 */
}

/* 行ごとのスタイル */
.msg-line,
.submsg-line {
  margin: 0;
  line-height: 1.2;
  width: 100%;
}

</style>